import { useMemo, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

export const ParentGate = ({ open, onOpenChange, onPass }) => {
  const [wrong, setWrong] = useState(false);
  const q = useMemo(() => {
    const a = 3 + Math.floor(Math.random() * 6);
    const b = 2 + Math.floor(Math.random() * 6);
    const opts = [a + b, a + b + 1, a + b - 2, a + b + 3].sort(() => Math.random() - 0.5);
    return { a, b, opts };
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const pick = (v) => {
    if (v === q.a + q.b) {
      setWrong(false);
      onPass();
    } else setWrong(true);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="font-serif-tc" data-testid="parent-gate-dialog">
        <DialogHeader>
          <DialogTitle>家長確認</DialogTitle>
        </DialogHeader>
        <p className="text-stone-600">請點選正確答案：<b>{q.a} + {q.b} = ?</b></p>
        <div className="grid grid-cols-4 gap-3 mt-2">
          {q.opts.map((o) => (
            <button key={o} data-testid={`parent-gate-option-${o}`} onClick={() => pick(o)} className="h-14 rounded-xl bg-amber-50 border-2 border-amber-200 text-xl font-bold hover:bg-amber-100">
              {o}
            </button>
          ))}
        </div>
        {wrong && <p className="text-red-600 text-sm" data-testid="parent-gate-error">不對喔，再試一次。</p>}
      </DialogContent>
    </Dialog>
  );
};
